/**
 * Bilingual host content (docs/prd-bilingual-content.md).
 * Shared by the backend validators, the translation endpoint and the forms.
 */

/** Which side of a zh/en pair. Mirrors the Prisma `ContentLang` enum. */
export type ContentLang = 'ZH' | 'EN';

/** The bilingual field pairs (PRD §2.1), plus a Pick's place name. */
export type BilingualFieldType =
  | 'activityTitle'
  | 'activityDescription'
  | 'sessionDescription'
  | 'passTitle'
  | 'passDescription'
  | 'courseTitle'
  | 'courseDescription'
  | 'lessonTitle'
  | 'hostBio'
  | 'placeName';

export const BILINGUAL_FIELD_TYPES: readonly BilingualFieldType[] = [
  'activityTitle',
  'activityDescription',
  'sessionDescription',
  'passTitle',
  'passDescription',
  'courseTitle',
  'courseDescription',
  'lessonTitle',
  'hostBio',
  'placeName',
];

/**
 * Per-side character limits after trim (PRD §2.1). The English side is 3x the
 * Chinese side so a Chinese text written to its limit still fits once translated.
 */
export const BILINGUAL_LIMITS: Record<BilingualFieldType, { ZH: number; EN: number }> = {
  activityTitle: { ZH: 100, EN: 300 },
  activityDescription: { ZH: 5000, EN: 15000 },
  sessionDescription: { ZH: 200, EN: 600 },
  passTitle: { ZH: 100, EN: 300 },
  passDescription: { ZH: 5000, EN: 15000 },
  courseTitle: { ZH: 100, EN: 300 },
  courseDescription: { ZH: 5000, EN: 15000 },
  lessonTitle: { ZH: 100, EN: 300 },
  hostBio: { ZH: 1000, EN: 3000 },
  placeName: { ZH: 100, EN: 300 },
};

/** Field types where at least one side must be filled (PRD §2.1). */
export const BILINGUAL_REQUIRED: Record<BilingualFieldType, boolean> = {
  activityTitle: true,
  activityDescription: false,
  sessionDescription: false,
  passTitle: true,
  passDescription: false,
  courseTitle: true,
  courseDescription: false,
  lessonTitle: true,
  hostBio: true,
  placeName: false,
};
